import React, { useEffect,useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import global from "../../global-variables";
import { Link ,useNavigate} from "react-router-dom";
import ScrollToTop from "react-scroll-to-top"
import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaInstagram, FaEnvelope, FaPhoneAlt, FaMap, FaChevronUp ,FaPinterest,FaWhatsapp,FaBlogger} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { HashLink } from "react-router-hash-link";

import WOW from 'wowjs';
import globalVariables from '../../global-variables';
import axios from 'axios';
import { scrollToTop } from './header';

export default function Footer() {

    const navigate = useNavigate();

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -134;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    useEffect(() => {

        // initiate the wow effect
        new WOW.WOW({
            live: false
        }).init();

    }, []);

    const [peopleCategory, setPeopleCategoryList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.pcategory_status = 1;
        
            axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getcategoryHavingPeopleList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                    {
                        navigate('/error-page')
                    }
                    else
                    {
                    // pass the result in the success function of the respective page
                    setPeopleCategoryList(response_list.data[0]);
                    }
                });
        

    }, [])

    const [socialMediaList, setSocialMediaList] = useState([])

    useEffect(() => {
        let _obj = new Object();
        _obj.social_status = 1;
        setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/socialApi/getSocialList", _obj)
                .then((response_list) => {
                    // pass the result in the success function of the respective page
                    setSocialMediaList(response_list.data[0]);
                });
        }, 300);

    }, [])

    const [setting, setSettingList] = useState([]);
    

    useEffect(() => {
        let _obj = new Object();
        _obj.setting_id = global.variables.strSetting_id;
        axios.post(global.variables.strApiUrl + "/settingApi/getCompanySettingList", _obj)
            .then((response_list) => {
                if(response_list.data === 'error')
                {
                    navigate('/error-page')
                }
                else
                {
                // pass the result in the success function of the respective page
                setSettingList(response_list.data[0]);
                }
            });
    }, [])

    const [diseaseCategory, setDiseaseCategoryList] = useState([]);
    

    useEffect(() => {
        let _obj = new Object();
        _obj.disease_cat_status = 1;
        setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseasecategoryApi/getcategoryHavingDiseaseList", _obj)
                .then((response_list) => {
                    // pass the result in the success function of the respective page
                    setDiseaseCategoryList(response_list.data[0]);
                });
        }, 300);

    }, [])

    return (
        <footer className="mt-auto footer">
            <Container fluid="xxl" className="pt-lg-5 pb-lg-4 py-4">
                <Row>
                    <Col xxl={3} lg={3} md={6} id="address">
                        <address className="text-md-start text-center">
                            {
                            setting.map((val_setting)=>{
                                return(
                                    <>

                                        <h6>{val_setting.setting_company}</h6>
                                        <p className="wow mb-2">{val_setting.setting_address}<br className="d-md-block d-none" />{`${val_setting.setting_city} ${val_setting.setting_pin}. ${val_setting.setting_country}`}.</p>
                                        <ul className="list-inline">
                                            <li className="d-lg-inline-block px-0 py-0 bg-transparent border-0">
                                                <FaEnvelope className="icon-16 me-2" /> <Link to={"mailto:"+ val_setting.setting_contact_email}>{val_setting.setting_contact_email}</Link>
                                            </li>
                                            <li className="d-lg-inline-block px-0 py-0 mb-1 bg-transparent border-0 me-lg-4">
                                                <FaPhoneAlt className="icon-16 me-2" />{val_setting.setting_phone}
                                            </li>  
                                        </ul>
                                    </>
                                )
                            })
                            }
                        </address>
                    </Col>
                    <Col xxl={9} lg={9} md={4} className="ms-auto mt-md-0 mt-4">
                        <div className="d-lg-flex justify-content-lg-between ps-lg-3 ps-xl-5 ms-xxl-5">
                            
                            <div className="d-lg-block d-none">
                                <h6 class="fw-semibold border-bottom">About Us</h6>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                    <Link to="/aboutus" onClick={scrollToTop} aria-label="Introduction">Introduction</Link>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                    <HashLink to="/aboutus#objectives" scroll={el => scrollWithOffset(el)}>Objectives</HashLink>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                    <HashLink to="/aboutus#whyiitb" scroll={el => scrollWithOffset(el)}>Why IITB</HashLink>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                    <Link to="/milestone" onClick={scrollToTop} aria-label="Milestones">Milestones</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="d-lg-block d-none">
                                <h6 class="fw-semibold border-bottom">People</h6>
                                <div class="d-flex text-md-start text-center justify-content-center">
                                    <ul class="list-group list-group-flush d-md-block d-flex flex-row">
                                        {
                                        peopleCategory.map((val_cat)=>{
                                            return(
                                                <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                                    <Link to={globalVariables.variables.strDomainUrl + "people/" + val_cat.pcategory_pagename} onClick={scrollToTop} aria-label="NDMC Team">
                                                        {val_cat.pcategory_name}
                                                    </Link>
                                                </li>
                                            )
                                        })
                                    }
                                    </ul>
                                </div>
                           </div>
                            
                           <div className="d-lg-block d-none">
                                <h6 class="fw-semibold border-bottom">Diseases</h6>
                                <ul class="list-group list-group-flush">
                                    
                                    <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                    <Link to={`${global.variables.strDomainUrl}disease/malaria`} onClick={scrollToTop} aria-label="Malaria">Malaria</Link>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                    <Link to={`${global.variables.strDomainUrl}disease/tuberculosis`} onClick={scrollToTop} aria-label="Tuberculosis">Tuberculosis</Link>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                    <Link to={`${global.variables.strDomainUrl}disease/measles`} onClick={scrollToTop} aria-label="Vaccine Preventable Diseases (VPDs)">
                                            Vaccine Preventable
                                            Diseases (VPDs)
                                        </Link>
                                    </li>
                                    <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                    <Link to={`${global.variables.strDomainUrl}disease/lymphatic-filariasis`} onClick={scrollToTop} aria-label="Neglected Tropical Diseases
                                        (NTDs)">
                                            Neglected Tropical Diseases
                                            (NTDs)
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h6 className="fw-semibold text-md-start text-center border-bottom  d-md-block d-none">
                                    Quick Links
                                </h6>
                                <div class="footer-links d-flex text-md-start text-center justify-content-lg-center justify-content-md-between justify-content-center">
                                    <ul class="list-group list-group-flush d-md-block d-flex flex-row">
                                        <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                        <Link to={globalVariables.variables.strDomainUrl} onClick={scrollToTop} aria-label="Home">Home</Link>
                                        </li>
                                        <li class="list-group-item bg-transparent py-1 px-0 border-0 d-md-block d-none">
                                        <Link to="/events" onClick={scrollToTop} aria-label="Events">News & Events</Link>
                                        </li>
                                        <li class="list-group-item bg-transparent py-1 px-0 border-0 d-md-block d-none">
                                        <Link to="/publications" onClick={scrollToTop} aria-label="Publications">Publications</Link>
                                        </li>
                                        <li class="list-group-item bg-transparent py-1 ps-0 border-0 d-md-none d-block">
                                        <Link to="/aboutus" onClick={scrollToTop} aria-label="About Us">
                                                About Us
                                            </Link>
                                        </li>  
                                        <li class="list-group-item bg-transparent py-1 px-0 border-0 d-md-block d-none">
                                        <Link to="/resources" onClick={scrollToTop} aria-label="Resources">Resources</Link>
                                        </li> 
                                    </ul>
                                    <ul class="list-group list-group-flush ps-xxl-4 d-md-block d-flex flex-row">
                                        
                                        {/* <li class="list-group-item bg-transparent py-1 px-0 border-0 d-md-block d-none">
                                        <Link to="/joinus" onClick={scrollToTop} aria-label="Resources">Join Us</Link>
                                        </li>  */}
                                        {/* <li class="list-group-item bg-transparent py-1 px-0 border-0 d-md-block d-none">
                                        <Link to="/blog" aria-label="Resources">Blog</Link>
                                        </li>  */}
                                        <li class="list-group-item bg-transparent py-1 ps-0 border-0">
                                        <Link to="/contactus" onClick={scrollToTop}  aria-label="Contact Us">Contact Us</Link>
                                        </li>
                                        <li class="list-group-item bg-transparent py-1 px-0 border-0">
                                        <Link to="/sitemap" onClick={scrollToTop}  aria-label="Sitemap">Sitemap</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                       
                    </Col>
                    <Col sm="12" className="text-center mt-3 py-3 ftr-bottom">
                    <div className="text-center">
                            © {new Date().getFullYear()}. National Disease Modelling Consortium.<br className="d-md-none d-block" /> All rights reserved.
                            Site Created by <Link to="https://www.designscape.co.in/" rel="noopener noreferrer" target="_blank">Designscape</Link>
                        </div>
                         <div className="text-center mt-4 m-0">
                            <ul className="social_media">
                                {
                                    socialMediaList.length > 0 ?

                                        socialMediaList?.map((val) => {
                                            return (
                                                <li className={val.social_name.toLowerCase()} key={val.social_id}>
                                                    {
                                                        val.social_img_name === 'FaLinkedinIn' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaLinkedinIn className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaInstagram' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaInstagram className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaFacebookF' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaFacebookF className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaYoutube' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaYoutube className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaXTwitter' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaXTwitter className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaWhatsapp' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaWhatsapp className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaPinterest' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaPinterest className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        val.social_img_name === 'FaBlogger' ?
                                                            <Link to={val.social_url} target="_blank" rel="noopener noreferrer" >
                                                                <FaBlogger className="icon-20" />
                                                            </Link>
                                                            :
                                                            null
                                                    }
                                                </li>
                                            )
                                        })
                                        :
                                        null
                                }
                            </ul>
                        </div>  
                    </Col>

                </Row>
            </Container>
            <ScrollToTop smooth className='animated fadeInRight'
                viewBox="0 0 24 24"
                svgPath="m12 6.879-7.061 7.06 2.122 2.122L12 11.121l4.939 4.94 2.122-2.122z"
            />
        </footer>
    )
} 